/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * OpenStore E-Commerce API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddToCartBody,
  AddressDetail,
  Banner,
  BulkAdjustInventory200,
  BulkAdjustInventoryBody,
  CartItem,
  CartResponse,
  Category,
  ClearCartParams,
  CommissionListResponse,
  Coupon,
  CouponValidation,
  CreateAddressBody,
  CreateBannerBody,
  CreateCategoryBody,
  CreateCouponBody,
  CreateCustomerBody,
  CreateOrderBody,
  CreatePayoutBody,
  CreateProductBody,
  CreateReturnBody,
  CreateReviewBody,
  Customer,
  CustomerListResponse,
  DashboardStats,
  DeleteShipment200,
  ErrorEnvelope,
  ErrorResponse,
  GetCartParams,
  GetOauthInstallation200,
  GetOauthScopes200,
  GetRecentOrdersParams,
  GetSalesChartParams,
  GetTopProductsParams,
  HealthStatus,
  InventoryAdjustBody,
  InventoryAdjustment,
  InventoryDashboard,
  InventoryProductRow,
  InventoryProductUpdateBody,
  ListCustomersParams,
  ListInventoryAlerts200,
  ListInventoryHistoryParams,
  ListInventoryProductsParams,
  ListMultiOffersParams,
  ListOrdersParams,
  ListProductsParams,
  ListReturnsParams,
  ListShipmentsParams,
  MerchantBankInfoBody,
  MerchantListWalletPayoutsParams,
  MerchantListWalletTransactionsParams,
  MerchantPaymentConfigBody,
  MerchantPaymentProviderView,
  MerchantShippingConfigBody,
  MerchantShippingProviderView,
  MultiOfferDetail,
  MultiOfferListResponse,
  MultiOfferUpsertBody,
  Order,
  OrderListResponse,
  OrderStatusCount,
  PayoutDetail,
  PayoutListResponse,
  PlatformExportPayoutsCsvParams,
  PlatformListCommissionsParams,
  PlatformListPayoutsParams,
  PlatformListWalletsParams,
  PlatformPaymentProvider,
  PlatformProviderCredentialsBody,
  PlatformProviderCredentialsResponse,
  PlatformProviderUpdateBody,
  PlatformShippingProvider,
  PostOauthRevokeBody,
  PostOauthToken200,
  PostOauthTokenBody,
  Product,
  ProductListResponse,
  ProofUploadUrlResponse,
  ReturnDetail,
  ReturnListResponse,
  Review,
  SalesChartPoint,
  Shipment,
  ShipmentCreateBody,
  ShipmentListItem,
  ShipmentUpdateBody,
  StoreSettings,
  TopProduct,
  UpdateAddressBody,
  UpdateBannerBody,
  UpdateCartItemBody,
  UpdateCategoryBody,
  UpdateCouponBody,
  UpdateCustomerBody,
  UpdateOrderStatusBody,
  UpdatePayoutBody,
  UpdateProductBody,
  UpdateReturnStatusBody,
  UpdateSettingsBody,
  UploadUrlRequest,
  UploadUrlResponse,
  ValidateCouponBody,
  WalletDetail,
  WalletDetailResponse,
  WalletListResponse,
  WalletTransactionListResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List products with filtering and pagination
 */
export const getListProductsUrl = (params?: ListProductsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/products?${stringifiedParams}`
    : `/api/products`;
};

export const listProducts = async (
  params?: ListProductsParams,
  options?: RequestInit,
): Promise<ProductListResponse> => {
  return customFetch<ProductListResponse>(getListProductsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListProductsQueryKey = (params?: ListProductsParams) => {
  return [`/api/products`, ...(params ? [params] : [])] as const;
};

export const getListProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({
    signal,
  }) => listProducts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProducts>>
>;
export type ListProductsQueryError = ErrorType<unknown>;

/**
 * @summary List products with filtering and pagination
 */

export function useListProducts<
  TData = Awaited<ReturnType<typeof listProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProductsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a product
 */
export const getCreateProductUrl = () => {
  return `/api/products`;
};

export const createProduct = async (
  createProductBody: CreateProductBody,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getCreateProductUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProductBody),
  });
};

export const getCreateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<CreateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<CreateProductBody> },
  TContext
> => {
  const mutationKey = ["createProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProduct>>,
    { data: BodyType<CreateProductBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createProduct(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProduct>>
>;
export type CreateProductMutationBody = BodyType<CreateProductBody>;
export type CreateProductMutationError = ErrorType<unknown>;

/**
 * @summary Create a product
 */
export const useCreateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<CreateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<CreateProductBody> },
  TContext
> => {
  return useMutation(getCreateProductMutationOptions(options));
};

/**
 * @summary Get product by ID
 */
export const getGetProductUrl = (id: number) => {
  return `/api/products/${id}`;
};

export const getProduct = async (
  id: number,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getGetProductUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProductQueryKey = (id: number) => {
  return [`/api/products/${id}`] as const;
};

export const getGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProduct>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({
    signal,
  }) => getProduct(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProduct>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProduct>>
>;
export type GetProductQueryError = ErrorType<void>;

/**
 * @summary Get product by ID
 */

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProduct>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProductQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a product
 */
export const getUpdateProductUrl = (id: number) => {
  return `/api/products/${id}`;
};

export const updateProduct = async (
  id: number,
  updateProductBody: UpdateProductBody,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getUpdateProductUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProductBody),
  });
};

export const getUpdateProductMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: number; data: BodyType<UpdateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: number; data: BodyType<UpdateProductBody> },
  TContext
> => {
  const mutationKey = ["updateProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProduct>>,
    { id: number; data: BodyType<UpdateProductBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProduct(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProduct>>
>;
export type UpdateProductMutationBody = BodyType<UpdateProductBody>;
export type UpdateProductMutationError = ErrorType<void>;

/**
 * @summary Update a product
 */
export const useUpdateProduct = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: number; data: BodyType<UpdateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: number; data: BodyType<UpdateProductBody> },
  TContext
> => {
  return useMutation(getUpdateProductMutationOptions(options));
};

/**
 * @summary Delete a product
 */
export const getDeleteProductUrl = (id: number) => {
  return `/api/products/${id}`;
};

export const deleteProduct = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteProductUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProduct>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProduct(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProduct>>
>;

export type DeleteProductMutationError = ErrorType<unknown>;

/**
 * @summary Delete a product
 */
export const useDeleteProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteProductMutationOptions(options));
};

/**
 * @summary List all categories
 */
export const getListCategoriesUrl = () => {
  return `/api/categories`;
};

export const listCategories = async (
  options?: RequestInit,
): Promise<Category[]> => {
  return customFetch<Category[]>(getListCategoriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCategoriesQueryKey = () => {
  return [`/api/categories`] as const;
};

export const getListCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({
    signal,
  }) => listCategories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCategories>>
>;
export type ListCategoriesQueryError = ErrorType<unknown>;

/**
 * @summary List all categories
 */

export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCategoriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a category
 */
export const getCreateCategoryUrl = () => {
  return `/api/categories`;
};

export const createCategory = async (
  createCategoryBody: CreateCategoryBody,
  options?: RequestInit,
): Promise<Category> => {
  return customFetch<Category>(getCreateCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCategoryBody),
  });
};

export const getCreateCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    { data: BodyType<CreateCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: BodyType<CreateCategoryBody> },
  TContext
> => {
  const mutationKey = ["createCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategory>>,
    { data: BodyType<CreateCategoryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategory>>
>;
export type CreateCategoryMutationBody = BodyType<CreateCategoryBody>;
export type CreateCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Create a category
 */
export const useCreateCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    { data: BodyType<CreateCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: BodyType<CreateCategoryBody> },
  TContext
> => {
  return useMutation(getCreateCategoryMutationOptions(options));
};

/**
 * @summary Get category by ID
 */
export const getGetCategoryUrl = (id: number) => {
  return `/api/categories/${id}`;
};

export const getCategory = async (
  id: number,
  options?: RequestInit,
): Promise<Category> => {
  return customFetch<Category>(getGetCategoryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCategoryQueryKey = (id: number) => {
  return [`/api/categories/${id}`] as const;
};

export const getGetCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCategory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategory>>> = ({
    signal,
  }) => getCategory(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategory>>
>;
export type GetCategoryQueryError = ErrorType<void>;

/**
 * @summary Get category by ID
 */

export function useGetCategory<
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCategory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCategoryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a category
 */
export const getUpdateCategoryUrl = (id: number) => {
  return `/api/categories/${id}`;
};

export const updateCategory = async (
  id: number,
  updateCategoryBody: UpdateCategoryBody,
  options?: RequestInit,
): Promise<Category> => {
  return customFetch<Category>(getUpdateCategoryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCategoryBody),
  });
};

export const getUpdateCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    { id: number; data: BodyType<UpdateCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { id: number; data: BodyType<UpdateCategoryBody> },
  TContext
> => {
  const mutationKey = ["updateCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCategory>>,
    { id: number; data: BodyType<UpdateCategoryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCategory>>
>;
export type UpdateCategoryMutationBody = BodyType<UpdateCategoryBody>;
export type UpdateCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Update a category
 */
export const useUpdateCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    { id: number; data: BodyType<UpdateCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { id: number; data: BodyType<UpdateCategoryBody> },
  TContext
> => {
  return useMutation(getUpdateCategoryMutationOptions(options));
};

/**
 * @summary Delete a category
 */
export const getDeleteCategoryUrl = (id: number) => {
  return `/api/categories/${id}`;
};

export const deleteCategory = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCategoryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCategory>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCategory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCategory>>
>;

export type DeleteCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Delete a category
 */
export const useDeleteCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCategoryMutationOptions(options));
};

/**
 * @summary List orders with filters
 */
export const getListOrdersUrl = (params?: ListOrdersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/orders?${stringifiedParams}`
    : `/api/orders`;
};

export const listOrders = async (
  params?: ListOrdersParams,
  options?: RequestInit,
): Promise<OrderListResponse> => {
  return customFetch<OrderListResponse>(getListOrdersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListOrdersQueryKey = (params?: ListOrdersParams) => {
  return [`/api/orders`, ...(params ? [params] : [])] as const;
};

export const getListOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({
    signal,
  }) => listOrders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrders>>
>;
export type ListOrdersQueryError = ErrorType<unknown>;

/**
 * @summary List orders with filters
 */

export function useListOrders<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Place a new order
 */
export const getCreateOrderUrl = () => {
  return `/api/orders`;
};

export const createOrder = async (
  createOrderBody: CreateOrderBody,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getCreateOrderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createOrderBody),
  });
};

export const getCreateOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { data: BodyType<CreateOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: BodyType<CreateOrderBody> },
  TContext
> => {
  const mutationKey = ["createOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrder>>,
    { data: BodyType<CreateOrderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrder>>
>;
export type CreateOrderMutationBody = BodyType<CreateOrderBody>;
export type CreateOrderMutationError = ErrorType<unknown>;

/**
 * @summary Place a new order
 */
export const useCreateOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { data: BodyType<CreateOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: BodyType<CreateOrderBody> },
  TContext
> => {
  return useMutation(getCreateOrderMutationOptions(options));
};

/**
 * @summary Get order by ID
 */
export const getGetOrderUrl = (id: number) => {
  return `/api/orders/${id}`;
};

export const getOrder = async (
  id: number,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getGetOrderUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetOrderQueryKey = (id: number) => {
  return [`/api/orders/${id}`] as const;
};

export const getGetOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({
    signal,
  }) => getOrder(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrder>>
>;
export type GetOrderQueryError = ErrorType<void>;

/**
 * @summary Get order by ID
 */

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update order status
 */
export const getUpdateOrderStatusUrl = (id: number) => {
  return `/api/orders/${id}/status`;
};

export const updateOrderStatus = async (
  id: number,
  updateOrderStatusBody: UpdateOrderStatusBody,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getUpdateOrderStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateOrderStatusBody),
  });
};

export const getUpdateOrderStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    TError,
    { id: number; data: BodyType<UpdateOrderStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrderStatus>>,
  TError,
  { id: number; data: BodyType<UpdateOrderStatusBody> },
  TContext
> => {
  const mutationKey = ["updateOrderStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    { id: number; data: BodyType<UpdateOrderStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOrderStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrderStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrderStatus>>
>;
export type UpdateOrderStatusMutationBody = BodyType<UpdateOrderStatusBody>;
export type UpdateOrderStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update order status
 */
export const useUpdateOrderStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    TError,
    { id: number; data: BodyType<UpdateOrderStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrderStatus>>,
  TError,
  { id: number; data: BodyType<UpdateOrderStatusBody> },
  TContext
> => {
  return useMutation(getUpdateOrderStatusMutationOptions(options));
};

/**
 * @summary List return requests
 */
export const getListReturnsUrl = (params?: ListReturnsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/returns?${stringifiedParams}`
    : `/api/returns`;
};

export const listReturns = async (
  params?: ListReturnsParams,
  options?: RequestInit,
): Promise<ReturnListResponse> => {
  return customFetch<ReturnListResponse>(getListReturnsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListReturnsQueryKey = (params?: ListReturnsParams) => {
  return [`/api/returns`, ...(params ? [params] : [])] as const;
};

export const getListReturnsQueryOptions = <
  TData = Awaited<ReturnType<typeof listReturns>>,
  TError = ErrorType<unknown>,
>(
  params?: ListReturnsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listReturns>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListReturnsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturns>>> = ({
    signal,
  }) => listReturns(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReturns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReturnsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReturns>>
>;
export type ListReturnsQueryError = ErrorType<unknown>;

/**
 * @summary List return requests
 */

export function useListReturns<
  TData = Awaited<ReturnType<typeof listReturns>>,
  TError = ErrorType<unknown>,
>(
  params?: ListReturnsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listReturns>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListReturnsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a return request
 */
export const getCreateReturnUrl = () => {
  return `/api/returns`;
};

export const createReturn = async (
  createReturnBody: CreateReturnBody,
  options?: RequestInit,
): Promise<ReturnDetail> => {
  return customFetch<ReturnDetail>(getCreateReturnUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createReturnBody),
  });
};

export const getCreateReturnMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReturn>>,
    TError,
    { data: BodyType<CreateReturnBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReturn>>,
  TError,
  { data: BodyType<CreateReturnBody> },
  TContext
> => {
  const mutationKey = ["createReturn"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReturn>>,
    { data: BodyType<CreateReturnBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createReturn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReturnMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReturn>>
>;
export type CreateReturnMutationBody = BodyType<CreateReturnBody>;
export type CreateReturnMutationError = ErrorType<unknown>;

/**
 * @summary Create a return request
 */
export const useCreateReturn = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReturn>>,
    TError,
    { data: BodyType<CreateReturnBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createReturn>>,
  TError,
  { data: BodyType<CreateReturnBody> },
  TContext
> => {
  return useMutation(getCreateReturnMutationOptions(options));
};

/**
 * @summary Get return by ID
 */
export const getGetReturnUrl = (id: number) => {
  return `/api/returns/${id}`;
};

export const getReturn = async (
  id: number,
  options?: RequestInit,
): Promise<ReturnDetail> => {
  return customFetch<ReturnDetail>(getGetReturnUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetReturnQueryKey = (id: number) => {
  return [`/api/returns/${id}`] as const;
};

export const getGetReturnQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturn>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReturn>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReturnQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturn>>> = ({
    signal,
  }) => getReturn(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetReturnQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReturn>>
>;
export type GetReturnQueryError = ErrorType<void>;

/**
 * @summary Get return by ID
 */

export function useGetReturn<
  TData = Awaited<ReturnType<typeof getReturn>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReturn>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReturnQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update return status (admin)
 */
export const getUpdateReturnStatusUrl = (id: number) => {
  return `/api/returns/${id}/status`;
};

export const updateReturnStatus = async (
  id: number,
  updateReturnStatusBody: UpdateReturnStatusBody,
  options?: RequestInit,
): Promise<ReturnDetail> => {
  return customFetch<ReturnDetail>(getUpdateReturnStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateReturnStatusBody),
  });
};

export const getUpdateReturnStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReturnStatus>>,
    TError,
    { id: number; data: BodyType<UpdateReturnStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReturnStatus>>,
  TError,
  { id: number; data: BodyType<UpdateReturnStatusBody> },
  TContext
> => {
  const mutationKey = ["updateReturnStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReturnStatus>>,
    { id: number; data: BodyType<UpdateReturnStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateReturnStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReturnStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReturnStatus>>
>;
export type UpdateReturnStatusMutationBody = BodyType<UpdateReturnStatusBody>;
export type UpdateReturnStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update return status (admin)
 */
export const useUpdateReturnStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReturnStatus>>,
    TError,
    { id: number; data: BodyType<UpdateReturnStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReturnStatus>>,
  TError,
  { id: number; data: BodyType<UpdateReturnStatusBody> },
  TContext
> => {
  return useMutation(getUpdateReturnStatusMutationOptions(options));
};

/**
 * @summary List multi offers
 */
export const getListMultiOffersUrl = (params?: ListMultiOffersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/multi-offers?${stringifiedParams}`
    : `/api/multi-offers`;
};

export const listMultiOffers = async (
  params?: ListMultiOffersParams,
  options?: RequestInit,
): Promise<MultiOfferListResponse> => {
  return customFetch<MultiOfferListResponse>(getListMultiOffersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMultiOffersQueryKey = (params?: ListMultiOffersParams) => {
  return [`/api/multi-offers`, ...(params ? [params] : [])] as const;
};

export const getListMultiOffersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMultiOffers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMultiOffersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMultiOffers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMultiOffersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMultiOffers>>> = ({
    signal,
  }) => listMultiOffers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMultiOffers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMultiOffersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMultiOffers>>
>;
export type ListMultiOffersQueryError = ErrorType<unknown>;

/**
 * @summary List multi offers
 */

export function useListMultiOffers<
  TData = Awaited<ReturnType<typeof listMultiOffers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMultiOffersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMultiOffers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMultiOffersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a multi offer
 */
export const getCreateMultiOfferUrl = () => {
  return `/api/multi-offers`;
};

export const createMultiOffer = async (
  multiOfferUpsertBody: MultiOfferUpsertBody,
  options?: RequestInit,
): Promise<MultiOfferDetail> => {
  return customFetch<MultiOfferDetail>(getCreateMultiOfferUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(multiOfferUpsertBody),
  });
};

export const getCreateMultiOfferMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMultiOffer>>,
    TError,
    { data: BodyType<MultiOfferUpsertBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMultiOffer>>,
  TError,
  { data: BodyType<MultiOfferUpsertBody> },
  TContext
> => {
  const mutationKey = ["createMultiOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMultiOffer>>,
    { data: BodyType<MultiOfferUpsertBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMultiOffer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMultiOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMultiOffer>>
>;
export type CreateMultiOfferMutationBody = BodyType<MultiOfferUpsertBody>;
export type CreateMultiOfferMutationError = ErrorType<unknown>;

/**
 * @summary Create a multi offer
 */
export const useCreateMultiOffer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMultiOffer>>,
    TError,
    { data: BodyType<MultiOfferUpsertBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMultiOffer>>,
  TError,
  { data: BodyType<MultiOfferUpsertBody> },
  TContext
> => {
  return useMutation(getCreateMultiOfferMutationOptions(options));
};

export const getGetMultiOfferUrl = (id: number) => {
  return `/api/multi-offers/${id}`;
};

export const getMultiOffer = async (
  id: number,
  options?: RequestInit,
): Promise<MultiOfferDetail> => {
  return customFetch<MultiOfferDetail>(getGetMultiOfferUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMultiOfferQueryKey = (id: number) => {
  return [`/api/multi-offers/${id}`] as const;
};

export const getGetMultiOfferQueryOptions = <
  TData = Awaited<ReturnType<typeof getMultiOffer>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMultiOffer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMultiOfferQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiOffer>>> = ({
    signal,
  }) => getMultiOffer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMultiOffer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMultiOfferQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMultiOffer>>
>;
export type GetMultiOfferQueryError = ErrorType<void>;

export function useGetMultiOffer<
  TData = Awaited<ReturnType<typeof getMultiOffer>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMultiOffer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMultiOfferQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateMultiOfferUrl = (id: number) => {
  return `/api/multi-offers/${id}`;
};

export const updateMultiOffer = async (
  id: number,
  multiOfferUpsertBody: MultiOfferUpsertBody,
  options?: RequestInit,
): Promise<MultiOfferDetail> => {
  return customFetch<MultiOfferDetail>(getUpdateMultiOfferUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(multiOfferUpsertBody),
  });
};

export const getUpdateMultiOfferMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMultiOffer>>,
    TError,
    { id: number; data: BodyType<MultiOfferUpsertBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMultiOffer>>,
  TError,
  { id: number; data: BodyType<MultiOfferUpsertBody> },
  TContext
> => {
  const mutationKey = ["updateMultiOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMultiOffer>>,
    { id: number; data: BodyType<MultiOfferUpsertBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMultiOffer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMultiOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMultiOffer>>
>;
export type UpdateMultiOfferMutationBody = BodyType<MultiOfferUpsertBody>;
export type UpdateMultiOfferMutationError = ErrorType<unknown>;

export const useUpdateMultiOffer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMultiOffer>>,
    TError,
    { id: number; data: BodyType<MultiOfferUpsertBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMultiOffer>>,
  TError,
  { id: number; data: BodyType<MultiOfferUpsertBody> },
  TContext
> => {
  return useMutation(getUpdateMultiOfferMutationOptions(options));
};

export const getDeleteMultiOfferUrl = (id: number) => {
  return `/api/multi-offers/${id}`;
};

export const deleteMultiOffer = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMultiOfferUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMultiOfferMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMultiOffer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMultiOffer>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMultiOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMultiOffer>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMultiOffer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMultiOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMultiOffer>>
>;

export type DeleteMultiOfferMutationError = ErrorType<unknown>;

export const useDeleteMultiOffer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMultiOffer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMultiOffer>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMultiOfferMutationOptions(options));
};

/**
 * @summary List customers
 */
export const getListCustomersUrl = (params?: ListCustomersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customers?${stringifiedParams}`
    : `/api/customers`;
};

export const listCustomers = async (
  params?: ListCustomersParams,
  options?: RequestInit,
): Promise<CustomerListResponse> => {
  return customFetch<CustomerListResponse>(getListCustomersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCustomersQueryKey = (params?: ListCustomersParams) => {
  return [`/api/customers`, ...(params ? [params] : [])] as const;
};

export const getListCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCustomersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({
    signal,
  }) => listCustomers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomers>>
>;
export type ListCustomersQueryError = ErrorType<unknown>;

/**
 * @summary List customers
 */

export function useListCustomers<
  TData = Awaited<ReturnType<typeof listCustomers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a customer
 */
export const getCreateCustomerUrl = () => {
  return `/api/customers`;
};

export const createCustomer = async (
  createCustomerBody: CreateCustomerBody,
  options?: RequestInit,
): Promise<Customer> => {
  return customFetch<Customer>(getCreateCustomerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCustomerBody),
  });
};

export const getCreateCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomer>>,
    TError,
    { data: BodyType<CreateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomer>>,
  TError,
  { data: BodyType<CreateCustomerBody> },
  TContext
> => {
  const mutationKey = ["createCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomer>>,
    { data: BodyType<CreateCustomerBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCustomer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomer>>
>;
export type CreateCustomerMutationBody = BodyType<CreateCustomerBody>;
export type CreateCustomerMutationError = ErrorType<unknown>;

/**
 * @summary Register a customer
 */
export const useCreateCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomer>>,
    TError,
    { data: BodyType<CreateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomer>>,
  TError,
  { data: BodyType<CreateCustomerBody> },
  TContext
> => {
  return useMutation(getCreateCustomerMutationOptions(options));
};

/**
 * @summary Get customer by ID
 */
export const getGetCustomerUrl = (id: number) => {
  return `/api/customers/${id}`;
};

export const getCustomer = async (
  id: number,
  options?: RequestInit,
): Promise<Customer> => {
  return customFetch<Customer>(getGetCustomerUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCustomerQueryKey = (id: number) => {
  return [`/api/customers/${id}`] as const;
};

export const getGetCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomer>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({
    signal,
  }) => getCustomer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomer>>
>;
export type GetCustomerQueryError = ErrorType<void>;

/**
 * @summary Get customer by ID
 */

export function useGetCustomer<
  TData = Awaited<ReturnType<typeof getCustomer>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update customer
 */
export const getUpdateCustomerUrl = (id: number) => {
  return `/api/customers/${id}`;
};

export const updateCustomer = async (
  id: number,
  updateCustomerBody: UpdateCustomerBody,
  options?: RequestInit,
): Promise<Customer> => {
  return customFetch<Customer>(getUpdateCustomerUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCustomerBody),
  });
};

export const getUpdateCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomer>>,
    TError,
    { id: number; data: BodyType<UpdateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomer>>,
  TError,
  { id: number; data: BodyType<UpdateCustomerBody> },
  TContext
> => {
  const mutationKey = ["updateCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomer>>,
    { id: number; data: BodyType<UpdateCustomerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCustomer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomer>>
>;
export type UpdateCustomerMutationBody = BodyType<UpdateCustomerBody>;
export type UpdateCustomerMutationError = ErrorType<unknown>;

/**
 * @summary Update customer
 */
export const useUpdateCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomer>>,
    TError,
    { id: number; data: BodyType<UpdateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCustomer>>,
  TError,
  { id: number; data: BodyType<UpdateCustomerBody> },
  TContext
> => {
  return useMutation(getUpdateCustomerMutationOptions(options));
};

/**
 * @summary Delete customer
 */
export const getDeleteCustomerUrl = (id: number) => {
  return `/api/customers/${id}`;
};

export const deleteCustomer = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCustomerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomer>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomer>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCustomer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomer>>
>;

export type DeleteCustomerMutationError = ErrorType<unknown>;

/**
 * @summary Delete customer
 */
export const useDeleteCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomer>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCustomerMutationOptions(options));
};

/**
 * @summary List customer addresses
 */
export const getListAddressesUrl = () => {
  return `/api/addresses`;
};

export const listAddresses = async (
  options?: RequestInit,
): Promise<AddressDetail[]> => {
  return customFetch<AddressDetail[]>(getListAddressesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAddressesQueryKey = () => {
  return [`/api/addresses`] as const;
};

export const getListAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAddresses>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAddresses>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAddressesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddresses>>> = ({
    signal,
  }) => listAddresses({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAddresses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAddresses>>
>;
export type ListAddressesQueryError = ErrorType<unknown>;

/**
 * @summary List customer addresses
 */

export function useListAddresses<
  TData = Awaited<ReturnType<typeof listAddresses>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAddresses>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAddressesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a new address
 */
export const getCreateAddressUrl = () => {
  return `/api/addresses`;
};

export const createAddress = async (
  createAddressBody: CreateAddressBody,
  options?: RequestInit,
): Promise<AddressDetail> => {
  return customFetch<AddressDetail>(getCreateAddressUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAddressBody),
  });
};

export const getCreateAddressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAddress>>,
    TError,
    { data: BodyType<CreateAddressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAddress>>,
  TError,
  { data: BodyType<CreateAddressBody> },
  TContext
> => {
  const mutationKey = ["createAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAddress>>,
    { data: BodyType<CreateAddressBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAddress>>
>;
export type CreateAddressMutationBody = BodyType<CreateAddressBody>;
export type CreateAddressMutationError = ErrorType<unknown>;

/**
 * @summary Add a new address
 */
export const useCreateAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAddress>>,
    TError,
    { data: BodyType<CreateAddressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAddress>>,
  TError,
  { data: BodyType<CreateAddressBody> },
  TContext
> => {
  return useMutation(getCreateAddressMutationOptions(options));
};

/**
 * @summary Update an address
 */
export const getUpdateAddressUrl = (id: number) => {
  return `/api/addresses/${id}`;
};

export const updateAddress = async (
  id: number,
  updateAddressBody: UpdateAddressBody,
  options?: RequestInit,
): Promise<AddressDetail> => {
  return customFetch<AddressDetail>(getUpdateAddressUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAddressBody),
  });
};

export const getUpdateAddressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddress>>,
    TError,
    { id: number; data: BodyType<UpdateAddressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAddress>>,
  TError,
  { id: number; data: BodyType<UpdateAddressBody> },
  TContext
> => {
  const mutationKey = ["updateAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAddress>>,
    { id: number; data: BodyType<UpdateAddressBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAddress(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAddress>>
>;
export type UpdateAddressMutationBody = BodyType<UpdateAddressBody>;
export type UpdateAddressMutationError = ErrorType<unknown>;

/**
 * @summary Update an address
 */
export const useUpdateAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddress>>,
    TError,
    { id: number; data: BodyType<UpdateAddressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAddress>>,
  TError,
  { id: number; data: BodyType<UpdateAddressBody> },
  TContext
> => {
  return useMutation(getUpdateAddressMutationOptions(options));
};

/**
 * @summary Delete an address
 */
export const getDeleteAddressUrl = (id: number) => {
  return `/api/addresses/${id}`;
};

export const deleteAddress = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAddressUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAddressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAddress>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAddress>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAddress>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAddress(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAddress>>
>;

export type DeleteAddressMutationError = ErrorType<unknown>;

/**
 * @summary Delete an address
 */
export const useDeleteAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAddress>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAddress>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAddressMutationOptions(options));
};

/**
 * @summary Set address as default
 */
export const getSetDefaultAddressUrl = (id: number) => {
  return `/api/addresses/${id}/default`;
};

export const setDefaultAddress = async (
  id: number,
  options?: RequestInit,
): Promise<AddressDetail> => {
  return customFetch<AddressDetail>(getSetDefaultAddressUrl(id), {
    ...options,
    method: "PATCH",
  });
};

export const getSetDefaultAddressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDefaultAddress>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDefaultAddress>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["setDefaultAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDefaultAddress>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return setDefaultAddress(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDefaultAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof setDefaultAddress>>
>;

export type SetDefaultAddressMutationError = ErrorType<unknown>;

/**
 * @summary Set address as default
 */
export const useSetDefaultAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDefaultAddress>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setDefaultAddress>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSetDefaultAddressMutationOptions(options));
};

/**
 * @summary Get cart items
 */
export const getGetCartUrl = (params: GetCartParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/cart?${stringifiedParams}`
    : `/api/cart`;
};

export const getCart = async (
  params: GetCartParams,
  options?: RequestInit,
): Promise<CartResponse> => {
  return customFetch<CartResponse>(getGetCartUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetCartQueryKey = (params?: GetCartParams) => {
  return [`/api/cart`, ...(params ? [params] : [])] as const;
};

export const getGetCartQueryOptions = <
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = ErrorType<unknown>,
>(
  params: GetCartParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCartQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCart>>> = ({
    signal,
  }) => getCart(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCart>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCart>>
>;
export type GetCartQueryError = ErrorType<unknown>;

/**
 * @summary Get cart items
 */

export function useGetCart<
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = ErrorType<unknown>,
>(
  params: GetCartParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCartQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add item to cart
 */
export const getAddToCartUrl = () => {
  return `/api/cart`;
};

export const addToCart = async (
  addToCartBody: AddToCartBody,
  options?: RequestInit,
): Promise<CartItem> => {
  return customFetch<CartItem>(getAddToCartUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addToCartBody),
  });
};

export const getAddToCartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addToCart>>,
    TError,
    { data: BodyType<AddToCartBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addToCart>>,
  TError,
  { data: BodyType<AddToCartBody> },
  TContext
> => {
  const mutationKey = ["addToCart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addToCart>>,
    { data: BodyType<AddToCartBody> }
  > = (props) => {
    const { data } = props ?? {};

    return addToCart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddToCartMutationResult = NonNullable<
  Awaited<ReturnType<typeof addToCart>>
>;
export type AddToCartMutationBody = BodyType<AddToCartBody>;
export type AddToCartMutationError = ErrorType<unknown>;

/**
 * @summary Add item to cart
 */
export const useAddToCart = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addToCart>>,
    TError,
    { data: BodyType<AddToCartBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addToCart>>,
  TError,
  { data: BodyType<AddToCartBody> },
  TContext
> => {
  return useMutation(getAddToCartMutationOptions(options));
};

/**
 * @summary Update cart item quantity
 */
export const getUpdateCartItemUrl = (id: number) => {
  return `/api/cart/${id}`;
};

export const updateCartItem = async (
  id: number,
  updateCartItemBody: UpdateCartItemBody,
  options?: RequestInit,
): Promise<CartItem> => {
  return customFetch<CartItem>(getUpdateCartItemUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCartItemBody),
  });
};

export const getUpdateCartItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCartItem>>,
    TError,
    { id: number; data: BodyType<UpdateCartItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCartItem>>,
  TError,
  { id: number; data: BodyType<UpdateCartItemBody> },
  TContext
> => {
  const mutationKey = ["updateCartItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCartItem>>,
    { id: number; data: BodyType<UpdateCartItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCartItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCartItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCartItem>>
>;
export type UpdateCartItemMutationBody = BodyType<UpdateCartItemBody>;
export type UpdateCartItemMutationError = ErrorType<unknown>;

/**
 * @summary Update cart item quantity
 */
export const useUpdateCartItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCartItem>>,
    TError,
    { id: number; data: BodyType<UpdateCartItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCartItem>>,
  TError,
  { id: number; data: BodyType<UpdateCartItemBody> },
  TContext
> => {
  return useMutation(getUpdateCartItemMutationOptions(options));
};

/**
 * @summary Remove item from cart
 */
export const getRemoveCartItemUrl = (id: number) => {
  return `/api/cart/${id}`;
};

export const removeCartItem = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemoveCartItemUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveCartItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeCartItem>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeCartItem>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["removeCartItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeCartItem>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return removeCartItem(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveCartItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeCartItem>>
>;

export type RemoveCartItemMutationError = ErrorType<unknown>;

/**
 * @summary Remove item from cart
 */
export const useRemoveCartItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeCartItem>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeCartItem>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRemoveCartItemMutationOptions(options));
};

/**
 * @summary Clear all cart items
 */
export const getClearCartUrl = (params: ClearCartParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/cart/clear?${stringifiedParams}`
    : `/api/cart/clear`;
};

export const clearCart = async (
  params: ClearCartParams,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getClearCartUrl(params), {
    ...options,
    method: "DELETE",
  });
};

export const getClearCartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearCart>>,
    TError,
    { params: ClearCartParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearCart>>,
  TError,
  { params: ClearCartParams },
  TContext
> => {
  const mutationKey = ["clearCart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearCart>>,
    { params: ClearCartParams }
  > = (props) => {
    const { params } = props ?? {};

    return clearCart(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearCartMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearCart>>
>;

export type ClearCartMutationError = ErrorType<unknown>;

/**
 * @summary Clear all cart items
 */
export const useClearCart = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearCart>>,
    TError,
    { params: ClearCartParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearCart>>,
  TError,
  { params: ClearCartParams },
  TContext
> => {
  return useMutation(getClearCartMutationOptions(options));
};

/**
 * @summary List reviews for a product
 */
export const getListProductReviewsUrl = (productId: number) => {
  return `/api/products/${productId}/reviews`;
};

export const listProductReviews = async (
  productId: number,
  options?: RequestInit,
): Promise<Review[]> => {
  return customFetch<Review[]>(getListProductReviewsUrl(productId), {
    ...options,
    method: "GET",
  });
};

export const getListProductReviewsQueryKey = (productId: number) => {
  return [`/api/products/${productId}/reviews`] as const;
};

export const getListProductReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProductReviews>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProductReviews>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListProductReviewsQueryKey(productId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProductReviews>>
  > = ({ signal }) =>
    listProductReviews(productId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!productId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listProductReviews>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProductReviewsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProductReviews>>
>;
export type ListProductReviewsQueryError = ErrorType<unknown>;

/**
 * @summary List reviews for a product
 */

export function useListProductReviews<
  TData = Awaited<ReturnType<typeof listProductReviews>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProductReviews>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProductReviewsQueryOptions(productId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a review
 */
export const getCreateReviewUrl = (productId: number) => {
  return `/api/products/${productId}/reviews`;
};

export const createReview = async (
  productId: number,
  createReviewBody: CreateReviewBody,
  options?: RequestInit,
): Promise<Review> => {
  return customFetch<Review>(getCreateReviewUrl(productId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createReviewBody),
  });
};

export const getCreateReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReview>>,
    TError,
    { productId: number; data: BodyType<CreateReviewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReview>>,
  TError,
  { productId: number; data: BodyType<CreateReviewBody> },
  TContext
> => {
  const mutationKey = ["createReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReview>>,
    { productId: number; data: BodyType<CreateReviewBody> }
  > = (props) => {
    const { productId, data } = props ?? {};

    return createReview(productId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReview>>
>;
export type CreateReviewMutationBody = BodyType<CreateReviewBody>;
export type CreateReviewMutationError = ErrorType<unknown>;

/**
 * @summary Add a review
 */
export const useCreateReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReview>>,
    TError,
    { productId: number; data: BodyType<CreateReviewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createReview>>,
  TError,
  { productId: number; data: BodyType<CreateReviewBody> },
  TContext
> => {
  return useMutation(getCreateReviewMutationOptions(options));
};

/**
 * @summary List coupons
 */
export const getListCouponsUrl = () => {
  return `/api/coupons`;
};

export const listCoupons = async (options?: RequestInit): Promise<Coupon[]> => {
  return customFetch<Coupon[]>(getListCouponsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCouponsQueryKey = () => {
  return [`/api/coupons`] as const;
};

export const getListCouponsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCoupons>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCoupons>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCouponsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoupons>>> = ({
    signal,
  }) => listCoupons({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCoupons>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCouponsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCoupons>>
>;
export type ListCouponsQueryError = ErrorType<unknown>;

/**
 * @summary List coupons
 */

export function useListCoupons<
  TData = Awaited<ReturnType<typeof listCoupons>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCoupons>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCouponsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a coupon
 */
export const getCreateCouponUrl = () => {
  return `/api/coupons`;
};

export const createCoupon = async (
  createCouponBody: CreateCouponBody,
  options?: RequestInit,
): Promise<Coupon> => {
  return customFetch<Coupon>(getCreateCouponUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCouponBody),
  });
};

export const getCreateCouponMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoupon>>,
    TError,
    { data: BodyType<CreateCouponBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCoupon>>,
  TError,
  { data: BodyType<CreateCouponBody> },
  TContext
> => {
  const mutationKey = ["createCoupon"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCoupon>>,
    { data: BodyType<CreateCouponBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCoupon(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCouponMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCoupon>>
>;
export type CreateCouponMutationBody = BodyType<CreateCouponBody>;
export type CreateCouponMutationError = ErrorType<unknown>;

/**
 * @summary Create a coupon
 */
export const useCreateCoupon = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoupon>>,
    TError,
    { data: BodyType<CreateCouponBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCoupon>>,
  TError,
  { data: BodyType<CreateCouponBody> },
  TContext
> => {
  return useMutation(getCreateCouponMutationOptions(options));
};

/**
 * @summary Get coupon by ID
 */
export const getGetCouponUrl = (id: number) => {
  return `/api/coupons/${id}`;
};

export const getCoupon = async (
  id: number,
  options?: RequestInit,
): Promise<Coupon> => {
  return customFetch<Coupon>(getGetCouponUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCouponQueryKey = (id: number) => {
  return [`/api/coupons/${id}`] as const;
};

export const getGetCouponQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoupon>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCoupon>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCouponQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupon>>> = ({
    signal,
  }) => getCoupon(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetCouponQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoupon>>
>;
export type GetCouponQueryError = ErrorType<unknown>;

/**
 * @summary Get coupon by ID
 */

export function useGetCoupon<
  TData = Awaited<ReturnType<typeof getCoupon>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCoupon>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCouponQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update coupon
 */
export const getUpdateCouponUrl = (id: number) => {
  return `/api/coupons/${id}`;
};

export const updateCoupon = async (
  id: number,
  updateCouponBody: UpdateCouponBody,
  options?: RequestInit,
): Promise<Coupon> => {
  return customFetch<Coupon>(getUpdateCouponUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCouponBody),
  });
};

export const getUpdateCouponMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoupon>>,
    TError,
    { id: number; data: BodyType<UpdateCouponBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCoupon>>,
  TError,
  { id: number; data: BodyType<UpdateCouponBody> },
  TContext
> => {
  const mutationKey = ["updateCoupon"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCoupon>>,
    { id: number; data: BodyType<UpdateCouponBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCoupon(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCouponMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCoupon>>
>;
export type UpdateCouponMutationBody = BodyType<UpdateCouponBody>;
export type UpdateCouponMutationError = ErrorType<unknown>;

/**
 * @summary Update coupon
 */
export const useUpdateCoupon = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoupon>>,
    TError,
    { id: number; data: BodyType<UpdateCouponBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCoupon>>,
  TError,
  { id: number; data: BodyType<UpdateCouponBody> },
  TContext
> => {
  return useMutation(getUpdateCouponMutationOptions(options));
};

/**
 * @summary Delete coupon
 */
export const getDeleteCouponUrl = (id: number) => {
  return `/api/coupons/${id}`;
};

export const deleteCoupon = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCouponUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCouponMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoupon>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCoupon>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCoupon"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCoupon>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCoupon(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCouponMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCoupon>>
>;

export type DeleteCouponMutationError = ErrorType<unknown>;

/**
 * @summary Delete coupon
 */
export const useDeleteCoupon = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoupon>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCoupon>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCouponMutationOptions(options));
};

/**
 * @summary Validate a coupon code
 */
export const getValidateCouponUrl = () => {
  return `/api/coupons/validate`;
};

export const validateCoupon = async (
  validateCouponBody: ValidateCouponBody,
  options?: RequestInit,
): Promise<CouponValidation> => {
  return customFetch<CouponValidation>(getValidateCouponUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(validateCouponBody),
  });
};

export const getValidateCouponMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateCoupon>>,
    TError,
    { data: BodyType<ValidateCouponBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateCoupon>>,
  TError,
  { data: BodyType<ValidateCouponBody> },
  TContext
> => {
  const mutationKey = ["validateCoupon"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateCoupon>>,
    { data: BodyType<ValidateCouponBody> }
  > = (props) => {
    const { data } = props ?? {};

    return validateCoupon(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateCouponMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateCoupon>>
>;
export type ValidateCouponMutationBody = BodyType<ValidateCouponBody>;
export type ValidateCouponMutationError = ErrorType<unknown>;

/**
 * @summary Validate a coupon code
 */
export const useValidateCoupon = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateCoupon>>,
    TError,
    { data: BodyType<ValidateCouponBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof validateCoupon>>,
  TError,
  { data: BodyType<ValidateCouponBody> },
  TContext
> => {
  return useMutation(getValidateCouponMutationOptions(options));
};

/**
 * @summary Get dashboard overview stats
 */
export const getGetDashboardStatsUrl = () => {
  return `/api/dashboard/stats`;
};

export const getDashboardStats = async (
  options?: RequestInit,
): Promise<DashboardStats> => {
  return customFetch<DashboardStats>(getGetDashboardStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardStatsQueryKey = () => {
  return [`/api/dashboard/stats`] as const;
};

export const getGetDashboardStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardStats>>
  > = ({ signal }) => getDashboardStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardStats>>
>;
export type GetDashboardStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard overview stats
 */

export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get recent orders for dashboard
 */
export const getGetRecentOrdersUrl = (params?: GetRecentOrdersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/recent-orders?${stringifiedParams}`
    : `/api/dashboard/recent-orders`;
};

export const getRecentOrders = async (
  params?: GetRecentOrdersParams,
  options?: RequestInit,
): Promise<Order[]> => {
  return customFetch<Order[]>(getGetRecentOrdersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentOrdersQueryKey = (params?: GetRecentOrdersParams) => {
  return [`/api/dashboard/recent-orders`, ...(params ? [params] : [])] as const;
};

export const getGetRecentOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecentOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentOrders>>> = ({
    signal,
  }) => getRecentOrders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentOrders>>
>;
export type GetRecentOrdersQueryError = ErrorType<unknown>;

/**
 * @summary Get recent orders for dashboard
 */

export function useGetRecentOrders<
  TData = Awaited<ReturnType<typeof getRecentOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get top selling products
 */
export const getGetTopProductsUrl = (params?: GetTopProductsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/top-products?${stringifiedParams}`
    : `/api/dashboard/top-products`;
};

export const getTopProducts = async (
  params?: GetTopProductsParams,
  options?: RequestInit,
): Promise<TopProduct[]> => {
  return customFetch<TopProduct[]>(getGetTopProductsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTopProductsQueryKey = (params?: GetTopProductsParams) => {
  return [`/api/dashboard/top-products`, ...(params ? [params] : [])] as const;
};

export const getGetTopProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTopProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTopProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopProducts>>> = ({
    signal,
  }) => getTopProducts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTopProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopProducts>>
>;
export type GetTopProductsQueryError = ErrorType<unknown>;

/**
 * @summary Get top selling products
 */

export function useGetTopProducts<
  TData = Awaited<ReturnType<typeof getTopProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTopProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTopProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopProductsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get sales data for charts
 */
export const getGetSalesChartUrl = (params?: GetSalesChartParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/sales-chart?${stringifiedParams}`
    : `/api/dashboard/sales-chart`;
};

export const getSalesChart = async (
  params?: GetSalesChartParams,
  options?: RequestInit,
): Promise<SalesChartPoint[]> => {
  return customFetch<SalesChartPoint[]>(getGetSalesChartUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSalesChartQueryKey = (params?: GetSalesChartParams) => {
  return [`/api/dashboard/sales-chart`, ...(params ? [params] : [])] as const;
};

export const getGetSalesChartQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesChart>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSalesChartParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSalesChart>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSalesChartQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesChart>>> = ({
    signal,
  }) => getSalesChart(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesChart>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSalesChartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesChart>>
>;
export type GetSalesChartQueryError = ErrorType<unknown>;

/**
 * @summary Get sales data for charts
 */

export function useGetSalesChart<
  TData = Awaited<ReturnType<typeof getSalesChart>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSalesChartParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSalesChart>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSalesChartQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get order counts by status
 */
export const getGetOrderStatusSummaryUrl = () => {
  return `/api/dashboard/order-status-summary`;
};

export const getOrderStatusSummary = async (
  options?: RequestInit,
): Promise<OrderStatusCount[]> => {
  return customFetch<OrderStatusCount[]>(getGetOrderStatusSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOrderStatusSummaryQueryKey = () => {
  return [`/api/dashboard/order-status-summary`] as const;
};

export const getGetOrderStatusSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderStatusSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrderStatusSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderStatusSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrderStatusSummary>>
  > = ({ signal }) => getOrderStatusSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderStatusSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrderStatusSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrderStatusSummary>>
>;
export type GetOrderStatusSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get order counts by status
 */

export function useGetOrderStatusSummary<
  TData = Awaited<ReturnType<typeof getOrderStatusSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrderStatusSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderStatusSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get store settings
 */
export const getGetSettingsUrl = () => {
  return `/api/settings`;
};

export const getSettings = async (
  options?: RequestInit,
): Promise<StoreSettings> => {
  return customFetch<StoreSettings>(getGetSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSettingsQueryKey = () => {
  return [`/api/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get store settings
 */

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update store settings
 */
export const getUpdateSettingsUrl = () => {
  return `/api/settings`;
};

export const updateSettings = async (
  updateSettingsBody: UpdateSettingsBody,
  options?: RequestInit,
): Promise<StoreSettings> => {
  return customFetch<StoreSettings>(getUpdateSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSettingsBody),
  });
};

export const getUpdateSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: BodyType<UpdateSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: BodyType<UpdateSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSettings>>,
    { data: BodyType<UpdateSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSettings>>
>;
export type UpdateSettingsMutationBody = BodyType<UpdateSettingsBody>;
export type UpdateSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update store settings
 */
export const useUpdateSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: BodyType<UpdateSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: BodyType<UpdateSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateSettingsMutationOptions(options));
};

/**
 * @summary List banners
 */
export const getListBannersUrl = () => {
  return `/api/banners`;
};

export const listBanners = async (options?: RequestInit): Promise<Banner[]> => {
  return customFetch<Banner[]>(getListBannersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListBannersQueryKey = () => {
  return [`/api/banners`] as const;
};

export const getListBannersQueryOptions = <
  TData = Awaited<ReturnType<typeof listBanners>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBanners>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBannersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBanners>>> = ({
    signal,
  }) => listBanners({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBanners>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBannersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBanners>>
>;
export type ListBannersQueryError = ErrorType<unknown>;

/**
 * @summary List banners
 */

export function useListBanners<
  TData = Awaited<ReturnType<typeof listBanners>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBanners>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBannersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a banner
 */
export const getCreateBannerUrl = () => {
  return `/api/banners`;
};

export const createBanner = async (
  createBannerBody: CreateBannerBody,
  options?: RequestInit,
): Promise<Banner> => {
  return customFetch<Banner>(getCreateBannerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBannerBody),
  });
};

export const getCreateBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBanner>>,
    TError,
    { data: BodyType<CreateBannerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBanner>>,
  TError,
  { data: BodyType<CreateBannerBody> },
  TContext
> => {
  const mutationKey = ["createBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBanner>>,
    { data: BodyType<CreateBannerBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBanner(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBanner>>
>;
export type CreateBannerMutationBody = BodyType<CreateBannerBody>;
export type CreateBannerMutationError = ErrorType<unknown>;

/**
 * @summary Create a banner
 */
export const useCreateBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBanner>>,
    TError,
    { data: BodyType<CreateBannerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBanner>>,
  TError,
  { data: BodyType<CreateBannerBody> },
  TContext
> => {
  return useMutation(getCreateBannerMutationOptions(options));
};

/**
 * @summary Update banner
 */
export const getUpdateBannerUrl = (id: number) => {
  return `/api/banners/${id}`;
};

export const updateBanner = async (
  id: number,
  updateBannerBody: UpdateBannerBody,
  options?: RequestInit,
): Promise<Banner> => {
  return customFetch<Banner>(getUpdateBannerUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBannerBody),
  });
};

export const getUpdateBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBanner>>,
    TError,
    { id: number; data: BodyType<UpdateBannerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBanner>>,
  TError,
  { id: number; data: BodyType<UpdateBannerBody> },
  TContext
> => {
  const mutationKey = ["updateBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBanner>>,
    { id: number; data: BodyType<UpdateBannerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBanner(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBanner>>
>;
export type UpdateBannerMutationBody = BodyType<UpdateBannerBody>;
export type UpdateBannerMutationError = ErrorType<unknown>;

/**
 * @summary Update banner
 */
export const useUpdateBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBanner>>,
    TError,
    { id: number; data: BodyType<UpdateBannerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBanner>>,
  TError,
  { id: number; data: BodyType<UpdateBannerBody> },
  TContext
> => {
  return useMutation(getUpdateBannerMutationOptions(options));
};

/**
 * @summary Delete banner
 */
export const getDeleteBannerUrl = (id: number) => {
  return `/api/banners/${id}`;
};

export const deleteBanner = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteBannerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBanner>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBanner>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBanner>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBanner(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBanner>>
>;

export type DeleteBannerMutationError = ErrorType<unknown>;

/**
 * @summary Delete banner
 */
export const useDeleteBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBanner>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBanner>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteBannerMutationOptions(options));
};

/**
 * Returns a presigned GCS URL for direct upload. The client sends JSON
metadata here, then uploads the file directly to the returned URL.

 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List payment providers in the catalog with platform-side stats.
 */
export const getPlatformListPaymentProvidersUrl = () => {
  return `/api/platform/payment-providers`;
};

export const platformListPaymentProviders = async (
  options?: RequestInit,
): Promise<PlatformPaymentProvider[]> => {
  return customFetch<PlatformPaymentProvider[]>(
    getPlatformListPaymentProvidersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlatformListPaymentProvidersQueryKey = () => {
  return [`/api/platform/payment-providers`] as const;
};

export const getPlatformListPaymentProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof platformListPaymentProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof platformListPaymentProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformListPaymentProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformListPaymentProviders>>
  > = ({ signal }) =>
    platformListPaymentProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformListPaymentProviders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformListPaymentProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformListPaymentProviders>>
>;
export type PlatformListPaymentProvidersQueryError = ErrorType<unknown>;

/**
 * @summary List payment providers in the catalog with platform-side stats.
 */

export function usePlatformListPaymentProviders<
  TData = Awaited<ReturnType<typeof platformListPaymentProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof platformListPaymentProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformListPaymentProvidersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformGetPaymentProviderUrl = (code: string) => {
  return `/api/platform/payment-providers/${code}`;
};

export const platformGetPaymentProvider = async (
  code: string,
  options?: RequestInit,
): Promise<PlatformPaymentProvider> => {
  return customFetch<PlatformPaymentProvider>(
    getPlatformGetPaymentProviderUrl(code),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlatformGetPaymentProviderQueryKey = (code: string) => {
  return [`/api/platform/payment-providers/${code}`] as const;
};

export const getPlatformGetPaymentProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof platformGetPaymentProvider>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformGetPaymentProvider>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformGetPaymentProviderQueryKey(code);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformGetPaymentProvider>>
  > = ({ signal }) =>
    platformGetPaymentProvider(code, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof platformGetPaymentProvider>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformGetPaymentProviderQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformGetPaymentProvider>>
>;
export type PlatformGetPaymentProviderQueryError = ErrorType<ErrorEnvelope>;

export function usePlatformGetPaymentProvider<
  TData = Awaited<ReturnType<typeof platformGetPaymentProvider>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformGetPaymentProvider>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformGetPaymentProviderQueryOptions(code, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformUpdatePaymentProviderUrl = (code: string) => {
  return `/api/platform/payment-providers/${code}`;
};

export const platformUpdatePaymentProvider = async (
  code: string,
  platformProviderUpdateBody: PlatformProviderUpdateBody,
  options?: RequestInit,
): Promise<PlatformPaymentProvider> => {
  return customFetch<PlatformPaymentProvider>(
    getPlatformUpdatePaymentProviderUrl(code),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformProviderUpdateBody),
    },
  );
};

export const getPlatformUpdatePaymentProviderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformUpdatePaymentProvider>>,
    TError,
    { code: string; data: BodyType<PlatformProviderUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformUpdatePaymentProvider>>,
  TError,
  { code: string; data: BodyType<PlatformProviderUpdateBody> },
  TContext
> => {
  const mutationKey = ["platformUpdatePaymentProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformUpdatePaymentProvider>>,
    { code: string; data: BodyType<PlatformProviderUpdateBody> }
  > = (props) => {
    const { code, data } = props ?? {};

    return platformUpdatePaymentProvider(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformUpdatePaymentProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformUpdatePaymentProvider>>
>;
export type PlatformUpdatePaymentProviderMutationBody =
  BodyType<PlatformProviderUpdateBody>;
export type PlatformUpdatePaymentProviderMutationError = ErrorType<unknown>;

export const usePlatformUpdatePaymentProvider = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformUpdatePaymentProvider>>,
    TError,
    { code: string; data: BodyType<PlatformProviderUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformUpdatePaymentProvider>>,
  TError,
  { code: string; data: BodyType<PlatformProviderUpdateBody> },
  TContext
> => {
  return useMutation(getPlatformUpdatePaymentProviderMutationOptions(options));
};

/**
 * @summary Encrypt and store the platform-shared credential bundle for a payment provider.
 */
export const getPlatformSetPaymentProviderCredentialsUrl = (code: string) => {
  return `/api/platform/payment-providers/${code}/credentials`;
};

export const platformSetPaymentProviderCredentials = async (
  code: string,
  platformProviderCredentialsBody: PlatformProviderCredentialsBody,
  options?: RequestInit,
): Promise<PlatformProviderCredentialsResponse> => {
  return customFetch<PlatformProviderCredentialsResponse>(
    getPlatformSetPaymentProviderCredentialsUrl(code),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformProviderCredentialsBody),
    },
  );
};

export const getPlatformSetPaymentProviderCredentialsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformSetPaymentProviderCredentials>>,
    TError,
    { code: string; data: BodyType<PlatformProviderCredentialsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformSetPaymentProviderCredentials>>,
  TError,
  { code: string; data: BodyType<PlatformProviderCredentialsBody> },
  TContext
> => {
  const mutationKey = ["platformSetPaymentProviderCredentials"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformSetPaymentProviderCredentials>>,
    { code: string; data: BodyType<PlatformProviderCredentialsBody> }
  > = (props) => {
    const { code, data } = props ?? {};

    return platformSetPaymentProviderCredentials(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformSetPaymentProviderCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformSetPaymentProviderCredentials>>
>;
export type PlatformSetPaymentProviderCredentialsMutationBody =
  BodyType<PlatformProviderCredentialsBody>;
export type PlatformSetPaymentProviderCredentialsMutationError =
  ErrorType<unknown>;

/**
 * @summary Encrypt and store the platform-shared credential bundle for a payment provider.
 */
export const usePlatformSetPaymentProviderCredentials = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformSetPaymentProviderCredentials>>,
    TError,
    { code: string; data: BodyType<PlatformProviderCredentialsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformSetPaymentProviderCredentials>>,
  TError,
  { code: string; data: BodyType<PlatformProviderCredentialsBody> },
  TContext
> => {
  return useMutation(
    getPlatformSetPaymentProviderCredentialsMutationOptions(options),
  );
};

export const getPlatformListShippingProvidersUrl = () => {
  return `/api/platform/shipping-providers`;
};

export const platformListShippingProviders = async (
  options?: RequestInit,
): Promise<PlatformShippingProvider[]> => {
  return customFetch<PlatformShippingProvider[]>(
    getPlatformListShippingProvidersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlatformListShippingProvidersQueryKey = () => {
  return [`/api/platform/shipping-providers`] as const;
};

export const getPlatformListShippingProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof platformListShippingProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof platformListShippingProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformListShippingProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformListShippingProviders>>
  > = ({ signal }) =>
    platformListShippingProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformListShippingProviders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformListShippingProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformListShippingProviders>>
>;
export type PlatformListShippingProvidersQueryError = ErrorType<unknown>;

export function usePlatformListShippingProviders<
  TData = Awaited<ReturnType<typeof platformListShippingProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof platformListShippingProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformListShippingProvidersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformGetShippingProviderUrl = (code: string) => {
  return `/api/platform/shipping-providers/${code}`;
};

export const platformGetShippingProvider = async (
  code: string,
  options?: RequestInit,
): Promise<PlatformShippingProvider> => {
  return customFetch<PlatformShippingProvider>(
    getPlatformGetShippingProviderUrl(code),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlatformGetShippingProviderQueryKey = (code: string) => {
  return [`/api/platform/shipping-providers/${code}`] as const;
};

export const getPlatformGetShippingProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof platformGetShippingProvider>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformGetShippingProvider>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformGetShippingProviderQueryKey(code);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformGetShippingProvider>>
  > = ({ signal }) =>
    platformGetShippingProvider(code, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof platformGetShippingProvider>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformGetShippingProviderQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformGetShippingProvider>>
>;
export type PlatformGetShippingProviderQueryError = ErrorType<ErrorEnvelope>;

export function usePlatformGetShippingProvider<
  TData = Awaited<ReturnType<typeof platformGetShippingProvider>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformGetShippingProvider>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformGetShippingProviderQueryOptions(
    code,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformUpdateShippingProviderUrl = (code: string) => {
  return `/api/platform/shipping-providers/${code}`;
};

export const platformUpdateShippingProvider = async (
  code: string,
  platformProviderUpdateBody: PlatformProviderUpdateBody,
  options?: RequestInit,
): Promise<PlatformShippingProvider> => {
  return customFetch<PlatformShippingProvider>(
    getPlatformUpdateShippingProviderUrl(code),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformProviderUpdateBody),
    },
  );
};

export const getPlatformUpdateShippingProviderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformUpdateShippingProvider>>,
    TError,
    { code: string; data: BodyType<PlatformProviderUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformUpdateShippingProvider>>,
  TError,
  { code: string; data: BodyType<PlatformProviderUpdateBody> },
  TContext
> => {
  const mutationKey = ["platformUpdateShippingProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformUpdateShippingProvider>>,
    { code: string; data: BodyType<PlatformProviderUpdateBody> }
  > = (props) => {
    const { code, data } = props ?? {};

    return platformUpdateShippingProvider(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformUpdateShippingProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformUpdateShippingProvider>>
>;
export type PlatformUpdateShippingProviderMutationBody =
  BodyType<PlatformProviderUpdateBody>;
export type PlatformUpdateShippingProviderMutationError = ErrorType<unknown>;

export const usePlatformUpdateShippingProvider = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformUpdateShippingProvider>>,
    TError,
    { code: string; data: BodyType<PlatformProviderUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformUpdateShippingProvider>>,
  TError,
  { code: string; data: BodyType<PlatformProviderUpdateBody> },
  TContext
> => {
  return useMutation(getPlatformUpdateShippingProviderMutationOptions(options));
};

export const getPlatformSetShippingProviderCredentialsUrl = (code: string) => {
  return `/api/platform/shipping-providers/${code}/credentials`;
};

export const platformSetShippingProviderCredentials = async (
  code: string,
  platformProviderCredentialsBody: PlatformProviderCredentialsBody,
  options?: RequestInit,
): Promise<PlatformProviderCredentialsResponse> => {
  return customFetch<PlatformProviderCredentialsResponse>(
    getPlatformSetShippingProviderCredentialsUrl(code),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformProviderCredentialsBody),
    },
  );
};

export const getPlatformSetShippingProviderCredentialsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformSetShippingProviderCredentials>>,
    TError,
    { code: string; data: BodyType<PlatformProviderCredentialsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformSetShippingProviderCredentials>>,
  TError,
  { code: string; data: BodyType<PlatformProviderCredentialsBody> },
  TContext
> => {
  const mutationKey = ["platformSetShippingProviderCredentials"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformSetShippingProviderCredentials>>,
    { code: string; data: BodyType<PlatformProviderCredentialsBody> }
  > = (props) => {
    const { code, data } = props ?? {};

    return platformSetShippingProviderCredentials(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformSetShippingProviderCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformSetShippingProviderCredentials>>
>;
export type PlatformSetShippingProviderCredentialsMutationBody =
  BodyType<PlatformProviderCredentialsBody>;
export type PlatformSetShippingProviderCredentialsMutationError =
  ErrorType<unknown>;

export const usePlatformSetShippingProviderCredentials = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformSetShippingProviderCredentials>>,
    TError,
    { code: string; data: BodyType<PlatformProviderCredentialsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformSetShippingProviderCredentials>>,
  TError,
  { code: string; data: BodyType<PlatformProviderCredentialsBody> },
  TContext
> => {
  return useMutation(
    getPlatformSetShippingProviderCredentialsMutationOptions(options),
  );
};

export const getPlatformListWalletsUrl = (
  params?: PlatformListWalletsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/platform/wallets?${stringifiedParams}`
    : `/api/platform/wallets`;
};

export const platformListWallets = async (
  params?: PlatformListWalletsParams,
  options?: RequestInit,
): Promise<WalletListResponse> => {
  return customFetch<WalletListResponse>(getPlatformListWalletsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getPlatformListWalletsQueryKey = (
  params?: PlatformListWalletsParams,
) => {
  return [`/api/platform/wallets`, ...(params ? [params] : [])] as const;
};

export const getPlatformListWalletsQueryOptions = <
  TData = Awaited<ReturnType<typeof platformListWallets>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformListWalletsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformListWallets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformListWalletsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformListWallets>>
  > = ({ signal }) =>
    platformListWallets(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformListWallets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformListWalletsQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformListWallets>>
>;
export type PlatformListWalletsQueryError = ErrorType<unknown>;

export function usePlatformListWallets<
  TData = Awaited<ReturnType<typeof platformListWallets>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformListWalletsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformListWallets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformListWalletsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformGetWalletUrl = (tenantId: number) => {
  return `/api/platform/wallets/${tenantId}`;
};

export const platformGetWallet = async (
  tenantId: number,
  options?: RequestInit,
): Promise<WalletDetailResponse> => {
  return customFetch<WalletDetailResponse>(getPlatformGetWalletUrl(tenantId), {
    ...options,
    method: "GET",
  });
};

export const getPlatformGetWalletQueryKey = (tenantId: number) => {
  return [`/api/platform/wallets/${tenantId}`] as const;
};

export const getPlatformGetWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof platformGetWallet>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  tenantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformGetWallet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformGetWalletQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformGetWallet>>
  > = ({ signal }) =>
    platformGetWallet(tenantId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof platformGetWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformGetWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformGetWallet>>
>;
export type PlatformGetWalletQueryError = ErrorType<ErrorEnvelope>;

export function usePlatformGetWallet<
  TData = Awaited<ReturnType<typeof platformGetWallet>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  tenantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformGetWallet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformGetWalletQueryOptions(tenantId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformListPayoutsUrl = (
  params?: PlatformListPayoutsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/platform/payouts?${stringifiedParams}`
    : `/api/platform/payouts`;
};

export const platformListPayouts = async (
  params?: PlatformListPayoutsParams,
  options?: RequestInit,
): Promise<PayoutListResponse> => {
  return customFetch<PayoutListResponse>(getPlatformListPayoutsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getPlatformListPayoutsQueryKey = (
  params?: PlatformListPayoutsParams,
) => {
  return [`/api/platform/payouts`, ...(params ? [params] : [])] as const;
};

export const getPlatformListPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof platformListPayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformListPayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformListPayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformListPayoutsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformListPayouts>>
  > = ({ signal }) =>
    platformListPayouts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformListPayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformListPayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformListPayouts>>
>;
export type PlatformListPayoutsQueryError = ErrorType<unknown>;

export function usePlatformListPayouts<
  TData = Awaited<ReturnType<typeof platformListPayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformListPayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformListPayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformListPayoutsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPlatformCreatePayoutUrl = () => {
  return `/api/platform/payouts`;
};

export const platformCreatePayout = async (
  createPayoutBody: CreatePayoutBody,
  options?: RequestInit,
): Promise<PayoutDetail> => {
  return customFetch<PayoutDetail>(getPlatformCreatePayoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPayoutBody),
  });
};

export const getPlatformCreatePayoutMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformCreatePayout>>,
    TError,
    { data: BodyType<CreatePayoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformCreatePayout>>,
  TError,
  { data: BodyType<CreatePayoutBody> },
  TContext
> => {
  const mutationKey = ["platformCreatePayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformCreatePayout>>,
    { data: BodyType<CreatePayoutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return platformCreatePayout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformCreatePayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformCreatePayout>>
>;
export type PlatformCreatePayoutMutationBody = BodyType<CreatePayoutBody>;
export type PlatformCreatePayoutMutationError = ErrorType<ErrorEnvelope>;

export const usePlatformCreatePayout = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformCreatePayout>>,
    TError,
    { data: BodyType<CreatePayoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformCreatePayout>>,
  TError,
  { data: BodyType<CreatePayoutBody> },
  TContext
> => {
  return useMutation(getPlatformCreatePayoutMutationOptions(options));
};

/**
 * @summary Download a CSV of payouts (default status=pending) for bulk bank import.
 */
export const getPlatformExportPayoutsCsvUrl = (
  params?: PlatformExportPayoutsCsvParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/platform/payouts/export.csv?${stringifiedParams}`
    : `/api/platform/payouts/export.csv`;
};

export const platformExportPayoutsCsv = async (
  params?: PlatformExportPayoutsCsvParams,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getPlatformExportPayoutsCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getPlatformExportPayoutsCsvQueryKey = (
  params?: PlatformExportPayoutsCsvParams,
) => {
  return [
    `/api/platform/payouts/export.csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlatformExportPayoutsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof platformExportPayoutsCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformExportPayoutsCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformExportPayoutsCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformExportPayoutsCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformExportPayoutsCsv>>
  > = ({ signal }) =>
    platformExportPayoutsCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformExportPayoutsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformExportPayoutsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformExportPayoutsCsv>>
>;
export type PlatformExportPayoutsCsvQueryError = ErrorType<unknown>;

/**
 * @summary Download a CSV of payouts (default status=pending) for bulk bank import.
 */

export function usePlatformExportPayoutsCsv<
  TData = Awaited<ReturnType<typeof platformExportPayoutsCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformExportPayoutsCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformExportPayoutsCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformExportPayoutsCsvQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mint a one-time pre-signed PUT URL for uploading a bank-transfer proof.
 */
export const getPlatformPayoutProofUploadUrlUrl = (id: number) => {
  return `/api/platform/payouts/${id}/proof-upload-url`;
};

export const platformPayoutProofUploadUrl = async (
  id: number,
  options?: RequestInit,
): Promise<ProofUploadUrlResponse> => {
  return customFetch<ProofUploadUrlResponse>(
    getPlatformPayoutProofUploadUrlUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPlatformPayoutProofUploadUrlMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformPayoutProofUploadUrl>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformPayoutProofUploadUrl>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["platformPayoutProofUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformPayoutProofUploadUrl>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return platformPayoutProofUploadUrl(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformPayoutProofUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformPayoutProofUploadUrl>>
>;

export type PlatformPayoutProofUploadUrlMutationError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Mint a one-time pre-signed PUT URL for uploading a bank-transfer proof.
 */
export const usePlatformPayoutProofUploadUrl = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformPayoutProofUploadUrl>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformPayoutProofUploadUrl>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlatformPayoutProofUploadUrlMutationOptions(options));
};

/**
 * @summary Advance the payout state machine (pending→processing→completed/failed/cancelled). On `completed` the merchant gets an email; on `failed`/`cancelled` the wallet is refunded.
 */
export const getPlatformUpdatePayoutUrl = (id: number) => {
  return `/api/platform/payouts/${id}`;
};

export const platformUpdatePayout = async (
  id: number,
  updatePayoutBody: UpdatePayoutBody,
  options?: RequestInit,
): Promise<PayoutDetail> => {
  return customFetch<PayoutDetail>(getPlatformUpdatePayoutUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePayoutBody),
  });
};

export const getPlatformUpdatePayoutMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformUpdatePayout>>,
    TError,
    { id: number; data: BodyType<UpdatePayoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformUpdatePayout>>,
  TError,
  { id: number; data: BodyType<UpdatePayoutBody> },
  TContext
> => {
  const mutationKey = ["platformUpdatePayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformUpdatePayout>>,
    { id: number; data: BodyType<UpdatePayoutBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return platformUpdatePayout(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformUpdatePayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof platformUpdatePayout>>
>;
export type PlatformUpdatePayoutMutationBody = BodyType<UpdatePayoutBody>;
export type PlatformUpdatePayoutMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Advance the payout state machine (pending→processing→completed/failed/cancelled). On `completed` the merchant gets an email; on `failed`/`cancelled` the wallet is refunded.
 */
export const usePlatformUpdatePayout = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformUpdatePayout>>,
    TError,
    { id: number; data: BodyType<UpdatePayoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof platformUpdatePayout>>,
  TError,
  { id: number; data: BodyType<UpdatePayoutBody> },
  TContext
> => {
  return useMutation(getPlatformUpdatePayoutMutationOptions(options));
};

export const getPlatformListCommissionsUrl = (
  params?: PlatformListCommissionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/platform/commissions?${stringifiedParams}`
    : `/api/platform/commissions`;
};

export const platformListCommissions = async (
  params?: PlatformListCommissionsParams,
  options?: RequestInit,
): Promise<CommissionListResponse> => {
  return customFetch<CommissionListResponse>(
    getPlatformListCommissionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlatformListCommissionsQueryKey = (
  params?: PlatformListCommissionsParams,
) => {
  return [`/api/platform/commissions`, ...(params ? [params] : [])] as const;
};

export const getPlatformListCommissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof platformListCommissions>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformListCommissionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformListCommissions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformListCommissionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformListCommissions>>
  > = ({ signal }) =>
    platformListCommissions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformListCommissions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlatformListCommissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformListCommissions>>
>;
export type PlatformListCommissionsQueryError = ErrorType<unknown>;

export function usePlatformListCommissions<
  TData = Awaited<ReturnType<typeof platformListCommissions>>,
  TError = ErrorType<unknown>,
>(
  params?: PlatformListCommissionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof platformListCommissions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlatformListCommissionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMerchantListPaymentProvidersUrl = () => {
  return `/api/admin/payment-providers`;
};

export const merchantListPaymentProviders = async (
  options?: RequestInit,
): Promise<MerchantPaymentProviderView[]> => {
  return customFetch<MerchantPaymentProviderView[]>(
    getMerchantListPaymentProvidersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getMerchantListPaymentProvidersQueryKey = () => {
  return [`/api/admin/payment-providers`] as const;
};

export const getMerchantListPaymentProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof merchantListPaymentProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof merchantListPaymentProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMerchantListPaymentProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof merchantListPaymentProviders>>
  > = ({ signal }) =>
    merchantListPaymentProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof merchantListPaymentProviders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MerchantListPaymentProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof merchantListPaymentProviders>>
>;
export type MerchantListPaymentProvidersQueryError = ErrorType<unknown>;

export function useMerchantListPaymentProviders<
  TData = Awaited<ReturnType<typeof merchantListPaymentProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof merchantListPaymentProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMerchantListPaymentProvidersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMerchantSetPaymentProviderConfigUrl = (code: string) => {
  return `/api/admin/payment-providers/${code}/config`;
};

export const merchantSetPaymentProviderConfig = async (
  code: string,
  merchantPaymentConfigBody: MerchantPaymentConfigBody,
  options?: RequestInit,
): Promise<MerchantPaymentProviderView> => {
  return customFetch<MerchantPaymentProviderView>(
    getMerchantSetPaymentProviderConfigUrl(code),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(merchantPaymentConfigBody),
    },
  );
};

export const getMerchantSetPaymentProviderConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof merchantSetPaymentProviderConfig>>,
    TError,
    { code: string; data: BodyType<MerchantPaymentConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof merchantSetPaymentProviderConfig>>,
  TError,
  { code: string; data: BodyType<MerchantPaymentConfigBody> },
  TContext
> => {
  const mutationKey = ["merchantSetPaymentProviderConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof merchantSetPaymentProviderConfig>>,
    { code: string; data: BodyType<MerchantPaymentConfigBody> }
  > = (props) => {
    const { code, data } = props ?? {};

    return merchantSetPaymentProviderConfig(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MerchantSetPaymentProviderConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof merchantSetPaymentProviderConfig>>
>;
export type MerchantSetPaymentProviderConfigMutationBody =
  BodyType<MerchantPaymentConfigBody>;
export type MerchantSetPaymentProviderConfigMutationError = ErrorType<unknown>;

export const useMerchantSetPaymentProviderConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof merchantSetPaymentProviderConfig>>,
    TError,
    { code: string; data: BodyType<MerchantPaymentConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof merchantSetPaymentProviderConfig>>,
  TError,
  { code: string; data: BodyType<MerchantPaymentConfigBody> },
  TContext
> => {
  return useMutation(
    getMerchantSetPaymentProviderConfigMutationOptions(options),
  );
};

export const getMerchantListShippingProvidersUrl = () => {
  return `/api/admin/shipping-providers`;
};

export const merchantListShippingProviders = async (
  options?: RequestInit,
): Promise<MerchantShippingProviderView[]> => {
  return customFetch<MerchantShippingProviderView[]>(
    getMerchantListShippingProvidersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getMerchantListShippingProvidersQueryKey = () => {
  return [`/api/admin/shipping-providers`] as const;
};

export const getMerchantListShippingProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof merchantListShippingProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof merchantListShippingProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMerchantListShippingProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof merchantListShippingProviders>>
  > = ({ signal }) =>
    merchantListShippingProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof merchantListShippingProviders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MerchantListShippingProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof merchantListShippingProviders>>
>;
export type MerchantListShippingProvidersQueryError = ErrorType<unknown>;

export function useMerchantListShippingProviders<
  TData = Awaited<ReturnType<typeof merchantListShippingProviders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof merchantListShippingProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMerchantListShippingProvidersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMerchantSetShippingProviderConfigUrl = (code: string) => {
  return `/api/admin/shipping-providers/${code}/config`;
};

export const merchantSetShippingProviderConfig = async (
  code: string,
  merchantShippingConfigBody: MerchantShippingConfigBody,
  options?: RequestInit,
): Promise<MerchantShippingProviderView> => {
  return customFetch<MerchantShippingProviderView>(
    getMerchantSetShippingProviderConfigUrl(code),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(merchantShippingConfigBody),
    },
  );
};

export const getMerchantSetShippingProviderConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof merchantSetShippingProviderConfig>>,
    TError,
    { code: string; data: BodyType<MerchantShippingConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof merchantSetShippingProviderConfig>>,
  TError,
  { code: string; data: BodyType<MerchantShippingConfigBody> },
  TContext
> => {
  const mutationKey = ["merchantSetShippingProviderConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof merchantSetShippingProviderConfig>>,
    { code: string; data: BodyType<MerchantShippingConfigBody> }
  > = (props) => {
    const { code, data } = props ?? {};

    return merchantSetShippingProviderConfig(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MerchantSetShippingProviderConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof merchantSetShippingProviderConfig>>
>;
export type MerchantSetShippingProviderConfigMutationBody =
  BodyType<MerchantShippingConfigBody>;
export type MerchantSetShippingProviderConfigMutationError = ErrorType<unknown>;

export const useMerchantSetShippingProviderConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof merchantSetShippingProviderConfig>>,
    TError,
    { code: string; data: BodyType<MerchantShippingConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof merchantSetShippingProviderConfig>>,
  TError,
  { code: string; data: BodyType<MerchantShippingConfigBody> },
  TContext
> => {
  return useMutation(
    getMerchantSetShippingProviderConfigMutationOptions(options),
  );
};

export const getMerchantGetWalletUrl = () => {
  return `/api/admin/wallet`;
};

export const merchantGetWallet = async (
  options?: RequestInit,
): Promise<WalletDetail> => {
  return customFetch<WalletDetail>(getMerchantGetWalletUrl(), {
    ...options,
    method: "GET",
  });
};

export const getMerchantGetWalletQueryKey = () => {
  return [`/api/admin/wallet`] as const;
};

export const getMerchantGetWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof merchantGetWallet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof merchantGetWallet>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMerchantGetWalletQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof merchantGetWallet>>
  > = ({ signal }) => merchantGetWallet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof merchantGetWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MerchantGetWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof merchantGetWallet>>
>;
export type MerchantGetWalletQueryError = ErrorType<unknown>;

export function useMerchantGetWallet<
  TData = Awaited<ReturnType<typeof merchantGetWallet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof merchantGetWallet>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMerchantGetWalletQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMerchantListWalletTransactionsUrl = (
  params?: MerchantListWalletTransactionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/wallet/transactions?${stringifiedParams}`
    : `/api/admin/wallet/transactions`;
};

export const merchantListWalletTransactions = async (
  params?: MerchantListWalletTransactionsParams,
  options?: RequestInit,
): Promise<WalletTransactionListResponse> => {
  return customFetch<WalletTransactionListResponse>(
    getMerchantListWalletTransactionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getMerchantListWalletTransactionsQueryKey = (
  params?: MerchantListWalletTransactionsParams,
) => {
  return [
    `/api/admin/wallet/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMerchantListWalletTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof merchantListWalletTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: MerchantListWalletTransactionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof merchantListWalletTransactions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMerchantListWalletTransactionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof merchantListWalletTransactions>>
  > = ({ signal }) =>
    merchantListWalletTransactions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof merchantListWalletTransactions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MerchantListWalletTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof merchantListWalletTransactions>>
>;
export type MerchantListWalletTransactionsQueryError = ErrorType<unknown>;

export function useMerchantListWalletTransactions<
  TData = Awaited<ReturnType<typeof merchantListWalletTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: MerchantListWalletTransactionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof merchantListWalletTransactions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMerchantListWalletTransactionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMerchantListWalletPayoutsUrl = (
  params?: MerchantListWalletPayoutsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/wallet/payouts?${stringifiedParams}`
    : `/api/admin/wallet/payouts`;
};

export const merchantListWalletPayouts = async (
  params?: MerchantListWalletPayoutsParams,
  options?: RequestInit,
): Promise<PayoutListResponse> => {
  return customFetch<PayoutListResponse>(
    getMerchantListWalletPayoutsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getMerchantListWalletPayoutsQueryKey = (
  params?: MerchantListWalletPayoutsParams,
) => {
  return [`/api/admin/wallet/payouts`, ...(params ? [params] : [])] as const;
};

export const getMerchantListWalletPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof merchantListWalletPayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: MerchantListWalletPayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof merchantListWalletPayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMerchantListWalletPayoutsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof merchantListWalletPayouts>>
  > = ({ signal }) =>
    merchantListWalletPayouts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof merchantListWalletPayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MerchantListWalletPayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof merchantListWalletPayouts>>
>;
export type MerchantListWalletPayoutsQueryError = ErrorType<unknown>;

export function useMerchantListWalletPayouts<
  TData = Awaited<ReturnType<typeof merchantListWalletPayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: MerchantListWalletPayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof merchantListWalletPayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMerchantListWalletPayoutsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMerchantSetBankInfoUrl = () => {
  return `/api/admin/wallet/bank-info`;
};

export const merchantSetBankInfo = async (
  merchantBankInfoBody: MerchantBankInfoBody,
  options?: RequestInit,
): Promise<WalletDetail> => {
  return customFetch<WalletDetail>(getMerchantSetBankInfoUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(merchantBankInfoBody),
  });
};

export const getMerchantSetBankInfoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof merchantSetBankInfo>>,
    TError,
    { data: BodyType<MerchantBankInfoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof merchantSetBankInfo>>,
  TError,
  { data: BodyType<MerchantBankInfoBody> },
  TContext
> => {
  const mutationKey = ["merchantSetBankInfo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof merchantSetBankInfo>>,
    { data: BodyType<MerchantBankInfoBody> }
  > = (props) => {
    const { data } = props ?? {};

    return merchantSetBankInfo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MerchantSetBankInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof merchantSetBankInfo>>
>;
export type MerchantSetBankInfoMutationBody = BodyType<MerchantBankInfoBody>;
export type MerchantSetBankInfoMutationError = ErrorType<unknown>;

export const useMerchantSetBankInfo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof merchantSetBankInfo>>,
    TError,
    { data: BodyType<MerchantBankInfoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof merchantSetBankInfo>>,
  TError,
  { data: BodyType<MerchantBankInfoBody> },
  TContext
> => {
  return useMutation(getMerchantSetBankInfoMutationOptions(options));
};

/**
 * @summary List shipments with optional filters
 */
export const getListShipmentsUrl = (params?: ListShipmentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/shipments?${stringifiedParams}`
    : `/api/shipments`;
};

export const listShipments = async (
  params?: ListShipmentsParams,
  options?: RequestInit,
): Promise<ShipmentListItem[]> => {
  return customFetch<ShipmentListItem[]>(getListShipmentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListShipmentsQueryKey = (params?: ListShipmentsParams) => {
  return [`/api/shipments`, ...(params ? [params] : [])] as const;
};

export const getListShipmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listShipments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListShipmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listShipments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListShipmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listShipments>>> = ({
    signal,
  }) => listShipments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listShipments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListShipmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listShipments>>
>;
export type ListShipmentsQueryError = ErrorType<unknown>;

/**
 * @summary List shipments with optional filters
 */

export function useListShipments<
  TData = Awaited<ReturnType<typeof listShipments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListShipmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listShipments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListShipmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a shipment for an order
 */
export const getCreateShipmentUrl = () => {
  return `/api/shipments`;
};

export const createShipment = async (
  shipmentCreateBody: ShipmentCreateBody,
  options?: RequestInit,
): Promise<Shipment> => {
  return customFetch<Shipment>(getCreateShipmentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(shipmentCreateBody),
  });
};

export const getCreateShipmentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShipment>>,
    TError,
    { data: BodyType<ShipmentCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createShipment>>,
  TError,
  { data: BodyType<ShipmentCreateBody> },
  TContext
> => {
  const mutationKey = ["createShipment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createShipment>>,
    { data: BodyType<ShipmentCreateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createShipment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateShipmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createShipment>>
>;
export type CreateShipmentMutationBody = BodyType<ShipmentCreateBody>;
export type CreateShipmentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a shipment for an order
 */
export const useCreateShipment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShipment>>,
    TError,
    { data: BodyType<ShipmentCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createShipment>>,
  TError,
  { data: BodyType<ShipmentCreateBody> },
  TContext
> => {
  return useMutation(getCreateShipmentMutationOptions(options));
};

/**
 * @summary Get a shipment by id
 */
export const getGetShipmentUrl = (id: number) => {
  return `/api/shipments/${id}`;
};

export const getShipment = async (
  id: number,
  options?: RequestInit,
): Promise<Shipment> => {
  return customFetch<Shipment>(getGetShipmentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetShipmentQueryKey = (id: number) => {
  return [`/api/shipments/${id}`] as const;
};

export const getGetShipmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getShipment>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShipment>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetShipmentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShipment>>> = ({
    signal,
  }) => getShipment(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getShipment>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetShipmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShipment>>
>;
export type GetShipmentQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a shipment by id
 */

export function useGetShipment<
  TData = Awaited<ReturnType<typeof getShipment>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShipment>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShipmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update tracking, carrier, status or notes
 */
export const getUpdateShipmentUrl = (id: number) => {
  return `/api/shipments/${id}`;
};

export const updateShipment = async (
  id: number,
  shipmentUpdateBody: ShipmentUpdateBody,
  options?: RequestInit,
): Promise<Shipment> => {
  return customFetch<Shipment>(getUpdateShipmentUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(shipmentUpdateBody),
  });
};

export const getUpdateShipmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShipment>>,
    TError,
    { id: number; data: BodyType<ShipmentUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateShipment>>,
  TError,
  { id: number; data: BodyType<ShipmentUpdateBody> },
  TContext
> => {
  const mutationKey = ["updateShipment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateShipment>>,
    { id: number; data: BodyType<ShipmentUpdateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateShipment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateShipmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateShipment>>
>;
export type UpdateShipmentMutationBody = BodyType<ShipmentUpdateBody>;
export type UpdateShipmentMutationError = ErrorType<unknown>;

/**
 * @summary Update tracking, carrier, status or notes
 */
export const useUpdateShipment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShipment>>,
    TError,
    { id: number; data: BodyType<ShipmentUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateShipment>>,
  TError,
  { id: number; data: BodyType<ShipmentUpdateBody> },
  TContext
> => {
  return useMutation(getUpdateShipmentMutationOptions(options));
};

/**
 * @summary Delete a shipment
 */
export const getDeleteShipmentUrl = (id: number) => {
  return `/api/shipments/${id}`;
};

export const deleteShipment = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteShipment200> => {
  return customFetch<DeleteShipment200>(getDeleteShipmentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteShipmentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShipment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteShipment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteShipment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteShipment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteShipment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteShipmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteShipment>>
>;

export type DeleteShipmentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a shipment
 */
export const useDeleteShipment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShipment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteShipment>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteShipmentMutationOptions(options));
};

/**
 * @summary List all shipments for a given order
 */
export const getListShipmentsByOrderUrl = (orderId: number) => {
  return `/api/shipments/by-order/${orderId}`;
};

export const listShipmentsByOrder = async (
  orderId: number,
  options?: RequestInit,
): Promise<Shipment[]> => {
  return customFetch<Shipment[]>(getListShipmentsByOrderUrl(orderId), {
    ...options,
    method: "GET",
  });
};

export const getListShipmentsByOrderQueryKey = (orderId: number) => {
  return [`/api/shipments/by-order/${orderId}`] as const;
};

export const getListShipmentsByOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof listShipmentsByOrder>>,
  TError = ErrorType<unknown>,
>(
  orderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listShipmentsByOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListShipmentsByOrderQueryKey(orderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listShipmentsByOrder>>
  > = ({ signal }) =>
    listShipmentsByOrder(orderId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!orderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listShipmentsByOrder>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListShipmentsByOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof listShipmentsByOrder>>
>;
export type ListShipmentsByOrderQueryError = ErrorType<unknown>;

/**
 * @summary List all shipments for a given order
 */

export function useListShipmentsByOrder<
  TData = Awaited<ReturnType<typeof listShipmentsByOrder>>,
  TError = ErrorType<unknown>,
>(
  orderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listShipmentsByOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListShipmentsByOrderQueryOptions(orderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns counters (total products tracked, total cost/retail value,
low-stock / out-of-stock / overstocked counts), plus the 10 most
recent stock adjustments, the top 5 movers in the last 30 days
and per-warehouse stock totals.

 * @summary Aggregate inventory health snapshot
 */
export const getGetInventoryDashboardUrl = () => {
  return `/api/inventory/dashboard`;
};

export const getInventoryDashboard = async (
  options?: RequestInit,
): Promise<InventoryDashboard> => {
  return customFetch<InventoryDashboard>(getGetInventoryDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetInventoryDashboardQueryKey = () => {
  return [`/api/inventory/dashboard`] as const;
};

export const getGetInventoryDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInventoryDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryDashboard>>
  > = ({ signal }) => getInventoryDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryDashboard>>
>;
export type GetInventoryDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Aggregate inventory health snapshot
 */

export function useGetInventoryDashboard<
  TData = Awaited<ReturnType<typeof getInventoryDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List products with stock-status filtering
 */
export const getListInventoryProductsUrl = (
  params?: ListInventoryProductsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/products?${stringifiedParams}`
    : `/api/inventory/products`;
};

export const listInventoryProducts = async (
  params?: ListInventoryProductsParams,
  options?: RequestInit,
): Promise<InventoryProductRow[]> => {
  return customFetch<InventoryProductRow[]>(
    getListInventoryProductsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInventoryProductsQueryKey = (
  params?: ListInventoryProductsParams,
) => {
  return [`/api/inventory/products`, ...(params ? [params] : [])] as const;
};

export const getListInventoryProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInventoryProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryProducts>>
  > = ({ signal }) =>
    listInventoryProducts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryProducts>>
>;
export type ListInventoryProductsQueryError = ErrorType<unknown>;

/**
 * @summary List products with stock-status filtering
 */

export function useListInventoryProducts<
  TData = Awaited<ReturnType<typeof listInventoryProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInventoryProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryProductsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update inventory-relevant fields on a product
 */
export const getUpdateInventoryProductUrl = (id: number) => {
  return `/api/inventory/products/${id}`;
};

export const updateInventoryProduct = async (
  id: number,
  inventoryProductUpdateBody: InventoryProductUpdateBody,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getUpdateInventoryProductUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inventoryProductUpdateBody),
  });
};

export const getUpdateInventoryProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryProduct>>,
    TError,
    { id: number; data: BodyType<InventoryProductUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInventoryProduct>>,
  TError,
  { id: number; data: BodyType<InventoryProductUpdateBody> },
  TContext
> => {
  const mutationKey = ["updateInventoryProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInventoryProduct>>,
    { id: number; data: BodyType<InventoryProductUpdateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInventoryProduct(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInventoryProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInventoryProduct>>
>;
export type UpdateInventoryProductMutationBody =
  BodyType<InventoryProductUpdateBody>;
export type UpdateInventoryProductMutationError = ErrorType<unknown>;

/**
 * @summary Update inventory-relevant fields on a product
 */
export const useUpdateInventoryProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryProduct>>,
    TError,
    { id: number; data: BodyType<InventoryProductUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInventoryProduct>>,
  TError,
  { id: number; data: BodyType<InventoryProductUpdateBody> },
  TContext
> => {
  return useMutation(getUpdateInventoryProductMutationOptions(options));
};

/**
 * Atomically updates `products.quantity`, optionally updates a
`warehouse_stock` row, and writes an immutable row to the
`stock_adjustments` ledger. Rejects if the resulting quantity
would go negative and the product does not allow back-orders.

 * @summary Apply a single stock adjustment (+/-) with audit trail
 */
export const getAdjustInventoryUrl = () => {
  return `/api/inventory/adjust`;
};

export const adjustInventory = async (
  inventoryAdjustBody: InventoryAdjustBody,
  options?: RequestInit,
): Promise<InventoryAdjustment> => {
  return customFetch<InventoryAdjustment>(getAdjustInventoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inventoryAdjustBody),
  });
};

export const getAdjustInventoryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustInventory>>,
    TError,
    { data: BodyType<InventoryAdjustBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustInventory>>,
  TError,
  { data: BodyType<InventoryAdjustBody> },
  TContext
> => {
  const mutationKey = ["adjustInventory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustInventory>>,
    { data: BodyType<InventoryAdjustBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adjustInventory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustInventoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustInventory>>
>;
export type AdjustInventoryMutationBody = BodyType<InventoryAdjustBody>;
export type AdjustInventoryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Apply a single stock adjustment (+/-) with audit trail
 */
export const useAdjustInventory = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustInventory>>,
    TError,
    { data: BodyType<InventoryAdjustBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adjustInventory>>,
  TError,
  { data: BodyType<InventoryAdjustBody> },
  TContext
> => {
  return useMutation(getAdjustInventoryMutationOptions(options));
};

/**
 * Iterates the `adjustments` array and applies each one. Rows with
an unknown `productId` are silently skipped. Negative resulting
quantities are clamped to zero. Each successful row writes an
immutable entry to the `stock_adjustments` ledger with
`type: "adjustment"`. Note: this endpoint is **not transactional** —
partial application is possible if the database errors mid-loop.

 * @summary Apply many stock adjustments sequentially
 */
export const getBulkAdjustInventoryUrl = () => {
  return `/api/inventory/bulk-adjust`;
};

export const bulkAdjustInventory = async (
  bulkAdjustInventoryBody: BulkAdjustInventoryBody,
  options?: RequestInit,
): Promise<BulkAdjustInventory200> => {
  return customFetch<BulkAdjustInventory200>(getBulkAdjustInventoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkAdjustInventoryBody),
  });
};

export const getBulkAdjustInventoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkAdjustInventory>>,
    TError,
    { data: BodyType<BulkAdjustInventoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkAdjustInventory>>,
  TError,
  { data: BodyType<BulkAdjustInventoryBody> },
  TContext
> => {
  const mutationKey = ["bulkAdjustInventory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkAdjustInventory>>,
    { data: BodyType<BulkAdjustInventoryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkAdjustInventory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkAdjustInventoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkAdjustInventory>>
>;
export type BulkAdjustInventoryMutationBody = BodyType<BulkAdjustInventoryBody>;
export type BulkAdjustInventoryMutationError = ErrorType<unknown>;

/**
 * @summary Apply many stock adjustments sequentially
 */
export const useBulkAdjustInventory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkAdjustInventory>>,
    TError,
    { data: BodyType<BulkAdjustInventoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkAdjustInventory>>,
  TError,
  { data: BodyType<BulkAdjustInventoryBody> },
  TContext
> => {
  return useMutation(getBulkAdjustInventoryMutationOptions(options));
};

/**
 * @summary Stock-adjustment ledger
 */
export const getListInventoryHistoryUrl = (
  params?: ListInventoryHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/history?${stringifiedParams}`
    : `/api/inventory/history`;
};

export const listInventoryHistory = async (
  params?: ListInventoryHistoryParams,
  options?: RequestInit,
): Promise<InventoryAdjustment[]> => {
  return customFetch<InventoryAdjustment[]>(
    getListInventoryHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInventoryHistoryQueryKey = (
  params?: ListInventoryHistoryParams,
) => {
  return [`/api/inventory/history`, ...(params ? [params] : [])] as const;
};

export const getListInventoryHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInventoryHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryHistory>>
  > = ({ signal }) =>
    listInventoryHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryHistory>>
>;
export type ListInventoryHistoryQueryError = ErrorType<unknown>;

/**
 * @summary Stock-adjustment ledger
 */

export function useListInventoryHistory<
  TData = Awaited<ReturnType<typeof listInventoryHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInventoryHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Low-stock, out-of-stock and overstocked alerts
 */
export const getListInventoryAlertsUrl = () => {
  return `/api/inventory/alerts`;
};

export const listInventoryAlerts = async (
  options?: RequestInit,
): Promise<ListInventoryAlerts200> => {
  return customFetch<ListInventoryAlerts200>(getListInventoryAlertsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInventoryAlertsQueryKey = () => {
  return [`/api/inventory/alerts`] as const;
};

export const getListInventoryAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryAlerts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryAlerts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInventoryAlertsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryAlerts>>
  > = ({ signal }) => listInventoryAlerts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryAlerts>>
>;
export type ListInventoryAlertsQueryError = ErrorType<unknown>;

/**
 * @summary Low-stock, out-of-stock and overstocked alerts
 */

export function useListInventoryAlerts<
  TData = Awaited<ReturnType<typeof listInventoryAlerts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryAlerts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryAlertsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Public endpoint. Returns id, English/Arabic labels and Arabic descriptions for every scope an app may request.
 * @summary List the public OAuth scope catalog
 */
export const getGetOauthScopesUrl = () => {
  return `/api/oauth/scopes`;
};

export const getOauthScopes = async (
  options?: RequestInit,
): Promise<GetOauthScopes200> => {
  return customFetch<GetOauthScopes200>(getGetOauthScopesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOauthScopesQueryKey = () => {
  return [`/api/oauth/scopes`] as const;
};

export const getGetOauthScopesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOauthScopes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOauthScopes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOauthScopesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOauthScopes>>> = ({
    signal,
  }) => getOauthScopes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOauthScopes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOauthScopesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOauthScopes>>
>;
export type GetOauthScopesQueryError = ErrorType<unknown>;

/**
 * @summary List the public OAuth scope catalog
 */

export function useGetOauthScopes<
  TData = Awaited<ReturnType<typeof getOauthScopes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOauthScopes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOauthScopesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Implements three OAuth 2.0 grants:
- `authorization_code` (with PKCE S256 — required)
- `refresh_token` (rotates the refresh token on each use)
- `client_credentials` (sandbox tenants only)

 * @summary Exchange an authorization code (or refresh token, or client credentials) for an access token
 */
export const getPostOauthTokenUrl = () => {
  return `/api/oauth/token`;
};

export const postOauthToken = async (
  postOauthTokenBody: PostOauthTokenBody,
  options?: RequestInit,
): Promise<PostOauthToken200> => {
  return customFetch<PostOauthToken200>(getPostOauthTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postOauthTokenBody),
  });
};

export const getPostOauthTokenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOauthToken>>,
    TError,
    { data: BodyType<PostOauthTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOauthToken>>,
  TError,
  { data: BodyType<PostOauthTokenBody> },
  TContext
> => {
  const mutationKey = ["postOauthToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOauthToken>>,
    { data: BodyType<PostOauthTokenBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postOauthToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOauthTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOauthToken>>
>;
export type PostOauthTokenMutationBody = BodyType<PostOauthTokenBody>;
export type PostOauthTokenMutationError = ErrorType<void>;

/**
 * @summary Exchange an authorization code (or refresh token, or client credentials) for an access token
 */
export const usePostOauthToken = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOauthToken>>,
    TError,
    { data: BodyType<PostOauthTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postOauthToken>>,
  TError,
  { data: BodyType<PostOauthTokenBody> },
  TContext
> => {
  return useMutation(getPostOauthTokenMutationOptions(options));
};

/**
 * @summary Revoke an access or refresh token
 */
export const getPostOauthRevokeUrl = () => {
  return `/api/oauth/revoke`;
};

export const postOauthRevoke = async (
  postOauthRevokeBody: PostOauthRevokeBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getPostOauthRevokeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postOauthRevokeBody),
  });
};

export const getPostOauthRevokeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOauthRevoke>>,
    TError,
    { data: BodyType<PostOauthRevokeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOauthRevoke>>,
  TError,
  { data: BodyType<PostOauthRevokeBody> },
  TContext
> => {
  const mutationKey = ["postOauthRevoke"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOauthRevoke>>,
    { data: BodyType<PostOauthRevokeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postOauthRevoke(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOauthRevokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOauthRevoke>>
>;
export type PostOauthRevokeMutationBody = BodyType<PostOauthRevokeBody>;
export type PostOauthRevokeMutationError = ErrorType<unknown>;

/**
 * @summary Revoke an access or refresh token
 */
export const usePostOauthRevoke = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOauthRevoke>>,
    TError,
    { data: BodyType<PostOauthRevokeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postOauthRevoke>>,
  TError,
  { data: BodyType<PostOauthRevokeBody> },
  TContext
> => {
  return useMutation(getPostOauthRevokeMutationOptions(options));
};

/**
 * Returns the tenant slug, granted scopes, and app id associated with the access token.
 * @summary Get the current install metadata for the bearer token
 */
export const getGetOauthInstallationUrl = () => {
  return `/api/oauth/installation`;
};

export const getOauthInstallation = async (
  options?: RequestInit,
): Promise<GetOauthInstallation200> => {
  return customFetch<GetOauthInstallation200>(getGetOauthInstallationUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOauthInstallationQueryKey = () => {
  return [`/api/oauth/installation`] as const;
};

export const getGetOauthInstallationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOauthInstallation>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOauthInstallation>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOauthInstallationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOauthInstallation>>
  > = ({ signal }) => getOauthInstallation({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOauthInstallation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOauthInstallationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOauthInstallation>>
>;
export type GetOauthInstallationQueryError = ErrorType<void>;

/**
 * @summary Get the current install metadata for the bearer token
 */

export function useGetOauthInstallation<
  TData = Awaited<ReturnType<typeof getOauthInstallation>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOauthInstallation>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOauthInstallationQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
